var Products = $.extend(false, BaseModule ,{
    api_route : 'products',

    data : {
        module      : 'products',
        page        : 1,
        limit       : 20,
        order_by    : 'id:desc'
    },
    
    before_save:function(){
        var module_name = this.data.module;
         $('form[name="'+module_name+'_form"] .template-builder').each(function(){          
            $(this).data('builder').commit();
        });  
    },

    after_load_entry:function(){
        "use strict";
        var module_name = this.data.module;
        this.save();
        this.categories_updated();
         $('form[name="'+module_name+'_form"] .template-builder').each(function(){        
            var b = $.extend( true , {}, Builder)  ;
            $(this).data('builder' , b );
            $(this).data('builder').set_target($(this)).setup();
        });
    },

     save_order:function(){
        var module_name = this.data.module,
            module = this,
            selection = [];
        
        $('input[name="order_item_id[]"]').each(function(){
            selection.push($(this).val());
        });

        $.ajax({
            url : API + module.api_route + '/order',
            method:'POST',
            data:{ 
                order_item_id: selection 
            },
            success:function(data){
                $("#"+module_name+"-dialog-list").modal('hide');
            }
        });
        return false;
    },
    
    categories_updated : function(){
        var tt = setInterval(function(){
            var d = [];
            $('.categories-visibility').hide();
            $('input[name="categories[]"]').each(function(){
                 $('.category-'+$(this).val()).show()
            });

            if($('#products_form').lenght == 0){
                clearInterval(tt);
            }
           

        },500);

    },
    init:function(){}
});

$(document).ready(function(){
    "use strict";
    Products.init();
});
